import React, { useEffect, useState, useCallback } from 'react'
import { CountUp } from 'use-count-up'
import axios from 'axios'
import { ReactComponent as WalletIcon } from '../../images/ic-wallet-w-bill.svg'
import dateFormat from 'dateformat'
import ReactMarkdown from 'react-markdown'
import { If, Then, Else } from 'react-if'
import { comma } from '../Func.js'
import { buildTimestamp } from '../../App.js'

function SummarySection({ RankData, address, profitData, userInfo, setInvestModalOpen, referralDownLine, sponsorDownLine }) {
    const userDeposit = profitData.deposit
    const [userNotice, setUserNotice] = useState([])
    const [date, setDate] = useState()

    const profitValue = (amount) => {
        if (amount === undefined || amount === 0 || amount === null) {
            return <CountUp end={0} thousandsSeparator="," />
        } else {
            return <CountUp isCounting end={amount} thousandsSeparator="," />
        }
    }

    function openInvest() {
        // if (userInfo.mining_remain_days >= 1 && userInfo.mining_remain_days <= 10) {
        //   alert("You can't invest because mining is over soon.");
        //   return;
        // }

        // alert(
        //   "Due to Polygon scan's API error, the deposit is not processed all day, and the marketing commission might be not paid normally, so all package investments will be canceled today(2024-02-07, UTC based).\n\nAlso, we will temporarily stop the 'Invest' function until Polygon scan is normalized."
        // );

        setInvestModalOpen(true)
    }
    const getUserNoticeList = useCallback(async () => {
        axios
            .post('api/getUserNoticeList', {
                address,
                buildTimestamp,
            })
            .then((res) => {
                setUserNotice(res.data)
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    }, [setUserNotice, address])

    function userNoticeConfirm(id) {
        axios
            .post('api/setUserNoticeConfirm', {
                address,
                id,
            })
            .then((res) => {
                getUserNoticeList()
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    }

    useEffect(() => {
        let now = new Date()
        let yesterday = new Date(now.setDate(now.getDate() - 1))
        setDate(dateFormat(yesterday, 'yyyy-m-d'))

        getUserNoticeList()
    }, [getUserNoticeList])

    const userNoticeRows = () => {
        if (userNotice && userNotice.length > 0) {
            return userNotice.map((row, idx) => (
                <div className="dashboard-box-message" key={idx}>
                    <div className="my-info-wrap">
                        <div className="info-text">Message</div>
                        <button className="btn btn-confirm" onClick={() => userNoticeConfirm(row.id)}>
                            Confirm
                        </button>
                    </div>
                    <div className="message">
                        <ReactMarkdown>{row.content}</ReactMarkdown>
                    </div>
                </div>
            ))
        } else {
            return ''
        }
    }

    const miningFinishNotice = () => {
        if (userInfo.creta_mining_sum > 0 && userInfo.mining_remain_days <= 10) {
            return (
                <div className="dashboard-box-message red">
                    <div className="my-info-wrap">
                        <div className="info-text">Message</div>
                    </div>
                    <div className="message">
                        <If condition={userInfo.mining_remain_days == 0}>
                            <Then>CRETA mining has ended. Please invest in the mining package again.</Then>
                            <Else>
                                CRETA Mining is {userInfo.mining_remain_days} day
                                {userInfo.mining_remain_days == 1 ? '' : 's'} away. Please invest in the mining package again after the end.
                            </Else>
                        </If>
                    </div>
                </div>
            )
        }

        return ''
    }

    const notAllowedExchangeWallet = () => {
        return (
            <div className="dashboard-box-message red">
                <div className="my-info-wrap">
                    <div className="info-text">Message</div>
                </div>
                <div className="message">
                    한국의 거래소 고팍스의 CRETA주소를 출금주소로 절대 셋팅하지 마세요. 트레블룰로 입금처리가 안됩니다.<br></br>
                    Never set the withdrawal address to the CRETA address of the Korean exchange 'Gopax.' Deposits cannot be processed for 'Treble Rule'.
                </div>
            </div>
        )
    }

    return (
        <>
            {/* <div className="current-creta-price">
                CRETA Price{' '}
                <b>
                    <span className="color-gold">${userInfo.creta_system_price}</span>
                </b>
            </div> */}
            <div className="dashboard-box">
                <div className="my-info-wrap">
                    <div className="info-text">
                        {userInfo.name}
                        <If condition={userInfo.deposit > 0}>
                            <Then>
                                <p className="deposit">PKG {profitValue(userInfo.deposit)}</p>
                            </Then>
                            <Else>
                                <p className="deposit">- No invested packages -</p>
                            </Else>
                        </If>
                    </div>

                    {/* <button className="btn btn-invest" onClick={() => openInvest()}>
            Invest
          </button> */}
                </div>
                <div className="my-info-wallet">
                    <div className="info-wallet mb-3">
                        <WalletIcon width={16} height={16} style={{ marginRight: 5, paddingBottom: 0 }} />
                        {address}
                    </div>
                    {/* <span className="rank">Rank : C{RankData}</span> */}
                </div>

                <If condition={userDeposit !== 0 || userInfo.creta_mining_sum > 0}>
                    <Then>
                        <div className="summary">
                            You earned{' '}
                            <strong>
                                {comma(userInfo.commission_sum)} <span className="usdt">USDT</span>
                            </strong>
                            <br />
                            You mined{' '}
                            <strong>
                                {comma(userInfo.creta_history_sum + userInfo.creta_mining_sum)} <span className="creta">CRETA</span>
                            </strong>
                            <br />
                            <em>≈ {comma(+Number((userInfo.creta_history_sum + userInfo.creta_mining_sum) * userInfo.creta_system_price).toFixed(1))} USDT</em>
                            <If condition={userInfo.mining_remain_days > 0}>
                                <Then>
                                    <br />( {userInfo.mining_remain_days} mining days remain )
                                </Then>
                            </If>
                        </div>
                    </Then>
                </If>
            </div>
            {notAllowedExchangeWallet()}
            {/* {miningFinishNotice()} */}
            {userNoticeRows()}

            {/* <div className="invest-title mb-3">Invest Summary </div> */}
            {/* <div className="dashboard-box-invest">
        <div>
          <p className="invest-header">Referral downline</p>
          <div>
            <div className="direction">
              <p>Left</p>
              <p>Right</p>
            </div>
            <div className="invest-referral">
              <If
                condition={userDeposit !== 0 || userInfo.creta_mining_sum > 0}
              >
                <Then>
                  <If
                    condition={referralDownLine.left < referralDownLine.right}
                  >
                    <Then>
                      <div>
                        <p className="minium-invest">
                          ${comma(referralDownLine.left)}
                        </p>
                        <p>${comma(referralDownLine.right)}</p>
                      </div>
                    </Then>
                    <Else>
                      <div>
                        <p>${comma(referralDownLine.left)}</p>{" "}
                        <p className="minium-invest">
                          ${comma(referralDownLine.right)}
                        </p>
                      </div>
                    </Else>
                  </If>
                </Then>
              </If>
            </div>
          </div>
        </div>
        <div>
          <p className="invest-header">Sponsor downline</p>
          <div>
            <div className="direction">
              <p>Left</p>
              <p>Right</p>
            </div>
            <div className="invest-sponsor">
              <If
                condition={userDeposit !== 0 || userInfo.creta_mining_sum > 0}
              >
                <Then>
                  <If condition={sponsorDownLine.left < sponsorDownLine.right}>
                    <Then>
                      <div>
                        <p className="minium-invest">
                          ${comma(sponsorDownLine.left)}
                        </p>
                        <p>${comma(sponsorDownLine.right)}</p>
                      </div>
                    </Then>
                    <Else>
                      <div>
                        <p>${comma(sponsorDownLine.left)}</p>
                        <p className="minium-invest">
                          ${comma(sponsorDownLine.right)}
                        </p>
                      </div>
                    </Else>
                  </If>
                </Then>
              </If>
            </div>
          </div>
        </div>
        <p className="w-100 color-gray text-right">updated at {date} 24:00</p>
      </div> */}
        </>
    )
}

export default SummarySection
